<script>
export default {
  props: {
    on: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <div>
    <svg v-if="on" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5Z"
        fill="#0058AA"
      />
      <path
        d="M11.1998 6.09998L8.95368 8.49998L7.83062 9.69998L6.70756 10.9L4.7998 8.49998"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg v-else width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8.5" r="7.6" fill="white" stroke="#C8C8C8" stroke-width="0.8" />
    </svg>
  </div>
</template>

<style scoped lang="scss"></style>
